import * as React from "react";
import * as ReactDOM from "react-dom";
import {
  MultiSelect,
  MultiSelectChangeEvent,
  MultiSelectFilterChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { useState } from "react";

export type Props  = {
  data?: {}[];
  // data?: {id: string, name: string}[];
  onChange?:any;
  value?:any;
  label?:string;
  defaultValue?:{}[];
  // defaultValues?:{skillId: number, skillName: string}[];
  ref?:any;
  placeholder?:string;
  disabled:boolean;
  dataItemKey?:any;
  textField?:string;
  
}

 const MultiSelectDropdown: React.FC<Props> = ({
  data = [],
  defaultValue = [],
  onChange,
  dataItemKey,
  placeholder,
  disabled,
  textField,
  label,
  ref,
  value,
    ...rest
  }) => {
 
   
    const [state, setState] = useState<any>({ newValue: data.slice()})
 
   const filterChange = (event: MultiSelectFilterChangeEvent) => {
      setState({
        newValue: filterBy(data.slice(), event.filter),
      })
    }

return (
    <div className="example-wrapper">
        <MultiSelect 
        data={state.newValue}
        filterable={true}
        onFilterChange={filterChange}
        onChange={onChange}
        placeholder={placeholder}
        defaultValue={defaultValue}
        label={label} 
        disabled={disabled}
        value={value}  
        textField={textField}
        ref={ref} 
        dataItemKey={dataItemKey} />      
    </div>
  )
}

export default MultiSelectDropdown;